<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ pageTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">{{ title }}</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="handleBack">返回</el-button>
        </div>

        <!-- 表单内容 -->
        <div class="content-wrap">
            <el-form :model="form" :rules="rules" ref="form" label-width="180px" class="announcement-form">
                <el-row :gutter="20">
                    <!-- 左列 -->
                    <el-col :span="12">
                        <!-- 原公告名称 -->
                        <el-form-item label="原公告名称:" v-if="type == 'change'">
                            <el-select v-model="form.tenderNoticeNames" placeholder="请选择原公告名称" style="width: 100%;"
                                disabled>
                            </el-select>
                        </el-form-item>

                        <!-- 标段名称 -->
                        <el-form-item label="标段名称:" prop="bidSectionList" required>
                            <el-select v-model="form.bidSectionList" placeholder="请选择标段" style="width: 100%;" multiple
                                :disabled="type == 'change'">
                                <template v-if="bidSectionList && bidSectionList.length > 0">
                                    <el-option v-for="(item, index) in bidSectionList"
                                        :key="`${item.bidSectionCode}-${index}`" :label="item.bidSectionName"
                                        :value="item.bidSectionCode">
                                    </el-option>
                                </template>
                            </el-select>
                        </el-form-item>

                        <!-- 公告发布时间 -->
                        <el-form-item label="变更公告发布时间:" prop="noticeSendTime" required>
                            <app-date-picker v-model="form.noticeSendTime" type="datetime" placeholder="选择日期时间"
                                style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>

                        <!-- 招标文件获取开始时间 -->
                        <el-form-item label="招标文件获取开始时间:" prop="biddingDocumentAcquisitionStartTime" required>
                            <app-date-picker v-model="form.biddingDocumentAcquisitionStartTime" type="datetime"
                                placeholder="选择日期时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>

                        <!-- 投标文件递交截止时间 -->
                        <el-form-item label="投标文件递交截止时间:" prop="bidDocumentSubmissionDeadline" required>
                            <app-date-picker v-model="form.bidDocumentSubmissionDeadline" type="datetime"
                                placeholder="选择日期时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>
                    </el-col>

                    <!-- 右列 -->
                    <el-col :span="12">
                        <!-- 公告名称 -->
                        <el-form-item label="公告名称:" prop="tenderNoticeName" required>
                            <el-input v-model="form.tenderNoticeName" placeholder="请输入公告名称"
                                style="width: 100%;"></el-input>
                        </el-form-item>

                        <!-- 公告结束时间 -->
                        <el-form-item label="变更公告结束时间:" prop="noticeEndTime" required>
                            <app-date-picker v-model="form.noticeEndTime" type="datetime" placeholder="选择日期时间"
                                style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>
                        <!-- 招标文件获取截止时间 -->
                        <el-form-item label="招标文件获取截止时间:" prop="biddingDocumentAcquisitionEndTime" required>
                            <app-date-picker v-model="form.biddingDocumentAcquisitionEndTime" type="datetime"
                                placeholder="选择日期时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss">
                            </app-date-picker>
                        </el-form-item>
                        <!-- 公告性质 -->
                        <!-- <el-form-item label="公告性质:" prop="noticeNature" required>
                            <el-radio-group v-model="form.noticeNature">
                                <el-radio :label="1">正常公告</el-radio>
                                <el-radio :label="2">变更公告</el-radio>
                            </el-radio-group>
                        </el-form-item> -->
                    </el-col>
                </el-row>

                <!-- 文件获取时间范围 -->
                <el-form-item label="文件获取时间范围:" prop="biddingDocumentAcquisitionScope" required>
                    <el-radio-group v-model="form.biddingDocumentAcquisitionScope">
                        <el-radio :label="1">投标人只能在公告发布期内下载文件</el-radio>
                        <el-radio :label="2">投标人可以在任意时间下载招标文件</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 是否涉密 -->
                <el-form-item label="是否涉密(发布信息是否包含国家秘密、工作秘密或涉密敏感信息):" prop="isConfidential" required
                    label-width="480px">
                    <el-radio-group v-model="form.isConfidential">
                        <el-radio :label="0">不包含</el-radio>
                        <el-radio :label="1">包含</el-radio>
                    </el-radio-group>
                </el-form-item>

                <!-- 公告内容 -->
                <el-form-item label="公告内容:" prop="noticeContent" required>
                    <RichTextEditor v-model="form.noticeContent" :height="400" placeholder="请输入公告内容..."
                        toolbar-type="default" />
                </el-form-item>

                <!-- 操作按钮 -->
                <el-form-item>
                    <el-button type="primary" @click="handleSubmit(0)">暂存</el-button>
                    <el-button type="primary" @click="handleSubmit(1)">保存并提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { addTenderNotice, initTenderNoticeData, getTenderNoticeDetail, getProjectDetail } from '@/api/agent/api'

export default {
    name: 'AddTenderAnnouncement',
    components: {
        RichTextEditor
    },
    data() {
        return {
            projectDetail: {},
            pageTitle: '',
            title: '新增招标公告',
            type: '',
            projectCode: '',
            projectData: {},
            bidSectionList: [], // 标段列表数据
            tenderNoticeCode: '',
            form: {
                originalNoticeCode: '',
                bidSectionList: [], // 存储选中的标段编号数组
                selectedSections: [], // 存储完整的标段对象数组
                tenderNoticeName: '',
                noticeSendTime: '',
                noticeEndTime: '',
                biddingDocumentAcquisitionStartTime: '',
                biddingDocumentAcquisitionEndTime: '',
                bidDocumentSubmissionDeadline: '',
                biddingDocumentAcquisitionScope: '',
                isConfidential: '',
                noticeContent: '',
                noticeNature: this.$route.query.type=="change"?2:1,
            },
            rules: {
                bidSectionList: [
                    { required: true, message: '请选择标段名称' },
                    { type: 'array', min: 1, message: '请至少选择一个标段' }
                ],
                tenderNoticeName: [
                    { required: true, message: '请输入公告名称' }
                ],
                noticeSendTime: [
                    { required: true, message: '请选择公告发布时间' }
                ],
                noticeEndTime: [
                    { required: true, message: '请选择公告结束时间' }
                ],
                biddingDocumentAcquisitionStartTime: [
                    { required: true, message: '请选择招标文件获取开始时间' }
                ],
                biddingDocumentAcquisitionEndTime: [
                    { required: true, message: '请选择招标文件获取截止时间'}
                ],
                bidDocumentSubmissionDeadline: [
                    { required: true, message: '请选择投标文件递交截止时间' }
                ],
                biddingDocumentAcquisitionScope: [
                    { required: true, message: '请选择文件获取时间范围' }
                ],
                isConfidential: [
                    { required: true, message: '请选择是否涉密' }
                ],
                noticeContent: [
                    { required: true, message: '请输入公告内容'}
                ],
                // noticeNature: [
                //     { required: true, message: '请输入公告内容', trigger: 'blur' }
                // ]
            }
        }
    },
    created() {
        this.type = this.$route.query.type
    },
    mounted() {
        this.type = this.$route.query.type
        this.initPage()
    },
    watch: {
        'form.bidSectionList': {
            handler(newVal) {
                if (!Array.isArray(newVal)) {
                    this.$set(this.form, 'bidSectionList', [])
                }
            },
            immediate: true
        }
    },
    methods: {
        /**
         * 初始化页面
         */
        initPage() {
            const projectCode = this.$route.query.projectCode
            if (this.$route.query.type == 'change' || this.$route.query.type == 'edit') {
                this.tenderNoticeCode = this.$route.query.originalNoticeCode
                this.getTenderNoticeDetail()
                if (this.$route.query.type == 'change') {
                    this.title = '发布变更公告'
                } else {
                    this.title = "编辑招标公告"
                }
            }
            if (!projectCode) {
                this.$message.error('缺少项目编号参数')
                this.$router.go(-1)
                return
            }
            this.projectCode = projectCode
            this.initTenderNoticeData()
            this.loadData()
        },
        async loadData() {
            const res = await getProjectDetail({ projectCode: this.projectCode })
            if (res.code === 200) {
                this.projectDetail = res.data
                this.pageTitle = this.$getProjectTypeName(res.data.projectType) + '--招标项目编号：' + res.data.projectCode + '　招标项目名称：' + res.data.projectName
            } else {
                this.$message.error('项目详情接口失败')
            }
        },



        /**
         * 初始化公告数据
         */
        async initTenderNoticeData() {
            let data = {
                projectCode: this.projectCode
            }
            if (this.$route.query.type == 'change') {
                data.originalTenderNoticeCode = this.$route.query.originalNoticeCode
            }
            const res = await initTenderNoticeData(data)
            if (res.code === 200) {
                this.projectData = res.data
                console.log('initTenderNoticeData - 获取到的项目数据:', res.data)
                if (res.data.bidSectionList && Array.isArray(res.data.bidSectionList)) {
                    const uniqueSections = []
                    const seenCodes = new Set()
                    res.data.bidSectionList.forEach(section => {
                        if (!seenCodes.has(section.bidSectionCode)) {
                            seenCodes.add(section.bidSectionCode)
                            uniqueSections.push(section)
                        }
                    })
                    this.bidSectionList = uniqueSections
                    console.log('initTenderNoticeData - 设置 bidSectionList:', this.bidSectionList)
                } else {
                    console.log('initTenderNoticeData - 没有标段数据或数据格式错误')
                }
            } else {
                this.$message.error('获取标段数据失败')
            }
        },
        /**
         * 获取公告详情
         */
        async getTenderNoticeDetail() {
            const res = await getTenderNoticeDetail({ tenderNoticeCode: this.tenderNoticeCode })
            if (res.code === 200) {
                const formData = { ...res.data }
                console.log('getTenderNoticeDetail - 获取到的数据:', formData)
                console.log('getTenderNoticeDetail - 当前 bidSectionList:', this.bidSectionList)

                // 变更公告
                if (this.$route.query.type == 'change') {
                    this.bidSectionList = formData.bidSectionList
                    this.form.tenderNoticeNames = formData.tenderNoticeName
                    if (formData.bidSectionList && formData.bidSectionList.length > 0) {
                        this.form.bidSectionList = formData.bidSectionList.map(item => item.bidSectionName)
                    } else {
                        this.form.bidSectionList = []
                    }
                    this.form.tenderNoticeName = formData.tenderNoticeName
                    // this.form.noticeSendTime = formData.noticeSendTime
                    // this.form.noticeEndTime = formData.noticeEndTime
                    // this.form.biddingDocumentAcquisitionStartTime = formData.biddingDocumentAcquisitionStartTime
                    // this.form.biddingDocumentAcquisitionEndTime = formData.biddingDocumentAcquisitionEndTime
                    // this.form.bidDocumentSubmissionDeadline = formData.bidDocumentSubmissionDeadline
                    this.form.biddingDocumentAcquisitionScope = formData.biddingDocumentAcquisitionScope
                    this.form.isConfidential = formData.isConfidential
                    this.form.noticeContent = formData.noticeContent
                } else {
                    // 编辑公告
                    this.form = formData
                    if (formData.bidSectionList) {
                        this.form.bidSectionList = formData.bidSectionList.map(item => item.bidSectionName)
                    } else {
                        this.form.bidSectionList = []
                    }
                }
            }
        },
        // 提交表单
        handleSubmit(status) {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.form.projectId = this.projectData.projectId
                    this.form.projectCode = this.projectData.projectCode
                    this.form.projectName = this.projectData.projectName
                    this.form.status = status
                    const selectedSectionCodes = this.form.bidSectionList;
                    const selectedSections = this.bidSectionList.filter(section =>
                        selectedSectionCodes.includes(section.bidSectionCode)
                    ).map(section => ({
                        bidSectionCode: section.bidSectionCode,
                        bidSectionName: section.bidSectionName,
                        id: section.id,
                        projectId: section.projectId,
                        sectionId: section.sectionId,
                        status: status,
                        tenderNoticeCode: section.tenderNoticeCode,
                        tenderNoticeId: section.tenderNoticeId
                    }))
                    this.form.selectedSections = selectedSections;
                    this.submitTenderNotice()

                } else {
                    this.$message.error('请完善必填信息')
                    return false
                }
            })
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 提交招标公告
        async submitTenderNotice() {
            const submitData = {
                ...this.form,
                bidSectionList: this.form.selectedSections || [],
                noticeType: 1
            };
            if (this.$route.query.type == 'change' || this.$route.query.type == 'edit') {
                submitData.originalNoticeCode = this.tenderNoticeCode
                submitData.bidSectionList = this.bidSectionList
            }
            try {
                const res = await addTenderNotice(submitData)
                if (res.code === 200) {
                    this.$message.success('提交成功')
                    this.$router.go(-1)
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                this.$message.error(res.msg)
            }


        }
    }
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-title {
    font-size: 16px;
    font-weight: 600;
    color: @gray-700;
    margin: 0;
    line-height: 1.5;
    position: relative;
    padding-left: 10px;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 16px;
        background: @primary-color;
        border-radius: 2px;
    }

    &:nth-child(2)::before {
        background: @gray-700;
    }
}

.content-wrap {
    background: #fff;
    padding: 30px;
    border-radius: 4px;
    box-shadow: @shadow-sm;
    margin-top: 20px;
    max-height: calc(100vh - 160px);
    overflow-y: auto;
}

.announcement-form {
    .el-form-item {
        margin-bottom: 20px;
        text-align: start;

        .el-form-item__label {
            font-weight: 500;
            color: @gray-700;
        }
    }

    .el-input__inner,
    .el-textarea__inner {
        border-color: @gray-300;
        color: @gray-700;

        &:focus {
            border-color: @primary-color;
        }

        &::placeholder {
            color: @gray-400;
        }

        &:disabled {
            background-color: @gray-100;
            color: @gray-500;
        }
    }
}
</style>
